import React, { FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './columns.module.scss'

interface TwoColumnProps extends HTMLAttributes<HTMLDivElement> {
  reverse?: boolean
}

export const TwoColumn: FC<TwoColumnProps> = ({
  reverse,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      classes.twoColumn,
      { [classes.reversed]: reverse },
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

export const ThreeColumn: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.threeColumn, className)} {...rest}>
    {children}
  </div>
)

export const FourColumn: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.fourColumn, className)} {...rest}>
    {children}
  </div>
)
